import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';

const ServicesOverview = ({ currentLanguage }) => {
  const content = {
    es: {
      title: "Nuestros Servicios",
      subtitle: "Soluciones completas para el mantenimiento de tu piscina",
      viewAll: "Ver todos los servicios"
    },
    en: {
      title: "Our Services",
      subtitle: "Complete solutions for your pool maintenance",
      viewAll: "View all services"
    }
  };

  const services = [
    {
      id: 1,
      icon: "Droplets",
      titleEs: "Limpieza Semanal",
      titleEn: "Weekly Cleaning",
      descriptionEs: "Servicio completo de limpieza y mantenimiento químico de tu piscina",
      descriptionEn: "Complete cleaning and chemical maintenance service for your pool",
      priceColones: "₡25,000",
      priceDollars: "$45",
      features: ["Aspirado del fondo", "Limpieza de paredes", "Balanceo químico", "Limpieza de filtros"]
    },
    {
      id: 2,
      icon: "Wrench",
      titleEs: "Mantenimiento de Equipos",
      titleEn: "Equipment Maintenance",
      descriptionEs: "Revisión y mantenimiento preventivo de bombas, filtros y sistemas",
      descriptionEn: "Inspection and preventive maintenance of pumps, filters and systems",
      priceColones: "₡15,000",
      priceDollars: "$27",
      features: ["Revisión de bombas", "Limpieza de filtros", "Calibración de equipos", "Reporte técnico"]
    },
    {
      id: 3,
      icon: "Zap",
      titleEs: "Servicio de Emergencia",
      titleEn: "Emergency Service",
      descriptionEs: "Atención inmediata para problemas urgentes en tu piscina",
      descriptionEn: "Immediate attention for urgent problems in your pool",
      priceColones: "₡35,000",
      priceDollars: "$63",
      features: ["Disponible 24/7", "Respuesta en 2 horas", "Diagnóstico incluido", "Reparaciones básicas"]
    }
  ];

  const text = content[currentLanguage];

  return (
    <section className="py-16 lg:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-4">
            {text.title}
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            {text.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.map((service) => (
            <div key={service.id} className="bg-background border border-border rounded-lg p-6 hover:shadow-medium nav-transition">
              {/* Service Icon */}
              <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
                <Icon name={service.icon} size={32} className="text-primary" />
              </div>

              {/* Service Info */}
              <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
                {currentLanguage === 'es' ? service.titleEs : service.titleEn}
              </h3>
              
              <p className="text-text-secondary mb-4">
                {currentLanguage === 'es' ? service.descriptionEs : service.descriptionEn}
              </p>

              {/* Pricing */}
              <div className="flex items-center space-x-4 mb-4">
                <span className="text-2xl font-bold text-primary">{service.priceColones}</span>
                <span className="text-lg text-text-secondary">/ {service.priceDollars}</span>
              </div>

              {/* Features */}
              <ul className="space-y-2 mb-6">
                {service.features.map((feature, index) => (
                  <li key={index} className="flex items-center space-x-2 text-sm text-text-secondary">
                    <Icon name="Check" size={16} className="text-success" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA Button */}
              <Link
                to="/contact-quote-request"
                className="w-full bg-primary text-white py-3 px-4 rounded-lg font-medium text-center hover:bg-primary/90 nav-transition block"
              >
                {currentLanguage === 'es' ? 'Solicitar' : 'Request'}
              </Link>
            </div>
          ))}
        </div>

        {/* View All Services */}
        <div className="text-center">
          <Link
            to="/services-catalog"
            className="inline-flex items-center space-x-2 text-primary font-medium hover:text-primary/80 nav-transition"
          >
            <span>{text.viewAll}</span>
            <Icon name="ArrowRight" size={20} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;